<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int" @change="selectSalesGroups()">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<em class="lt_text">Sales Team</em>
				<span class="int_type_no_border mgr_5"> <CodeSelect :codes="salesteams" :width="60" :displayDescription="true" v-model="salesteam_code" @set-code="setSalesteam" /> </span>

				<input type="text" v-model="keyword" class="tbl_int sm_int" placeholder="Keyword" />

				<!-- <em class="lt_text">{{ salesteam_name }}</em> -->
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_tbl">
				<div class="fixed-table-container">
					<div class="table-wrapper">
						<table id="item_list" class="list_tbl tbl_pointer">
							<thead>
								<tr>
									<!-- #3252 : beautyplus 는 Order 대신 맨 앞 No.(행 번호)를 보여준다. 다른 회사는 종전 그대로다. -->
									<th v-if="isBeautyplus" style="text-align:center;width: 4%;"><div class="th-text">No.</div></th>
									<th style="text-align:center;width: 7%;"><div class="th-text">Code</div></th>
									<th style="text-align:center;width: 15%;"><div class="th-text">Name</div></th>
									<!-- #3252 : beautyplus 는 수기 Description 대신 Partner 배정 기준 Territory 를 보여준다. -->
									<th style="text-align:center;width: 23%">
										<div class="th-text">{{ isBeautyplus ? 'Territory' : 'Description' }}</div>
									</th>
									<th style="text-align:center;width: 15%;"><div class="th-text">Team</div></th>
									<th style="text-align:center;width: 23%"><div class="th-text">Team-Description</div></th>
									<th style="text-align:center;width: 7%"><div class="th-text">Backup</div></th>
									<th v-if="!isBeautyplus" style="text-align:center;width: 5%;"><div class="th-text">Order</div></th>
									<th style="text-align:center;width: 5%;"><div class="th-text">Active</div></th>
								</tr>
							</thead>

							<tbody>
								<tr v-for="(group, index) in filteredSalesGroups" v-bind:key="group.code" v-bind:class="{ on: group.code == selectedSalesGroup.code }" @click="selectRow(group)">
									<td v-if="isBeautyplus" style="text-align:right;">{{ index + 1 }}</td>
									<td>{{ group.code }}</td>
									<td>{{ group.name }}</td>
									<td>{{ isBeautyplus ? territoryOf(group) : group.description }}</td>
									<td>{{ group.sales_team_name }}</td>
									<td>{{ group.team_description }}</td>
									<td style="text-align:right;">{{ group.backup_count }}</td>
									<td v-if="!isBeautyplus" style="text-align:right;">{{ group.order_no }}</td>
									<td style="text-align:center;">{{ group.active_yn }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div style="text-align:right;padding-top:5px; padding-right:10px;">Total Count : {{ filteredSalesGroups.length | commaSeparated }}</div>

				<div class="view_bottom_bt">
					<!-- <a href="javascript:;" class="gray_bt" @click="selectCodes()">Reload</a>
					&nbsp; -->
					<a v-if="modifiable" href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
				</div>
			</div>

			<div class="right_tbl">
				<div>
					<h4 class="inner_h5">{{ detailTitle }}</h4>
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:90px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Code</th>
								<td>
									<input type="text" v-model.trim="salesGroup.code" ref="code" class="tbl_int sm_int" v-bind:disabled="mode == 'detail'" />
									<button v-if="mode == 'add'" v-bind:disabled="!salesGroup.code" class="gray_bt" @click="checkDup()">Check Dup.</button>
								</td>
							</tr>
							<tr>
								<th>Name</th>
								<td><input type="text" v-model.trim="salesGroup.name" class="tbl_int full_int" /></td>
							</tr>
							<th>Team</th>
							<td>
								<!-- <input type="text" v-model.trim="salesGroup.sales_team_code" ref="code" class="tbl_int sm_int" v-bind:disabled="mode == 'detail'" /> -->
								<span class="int_type_no_border">
									<CodeSelect :codes="salesteams" :width="60" :descWidth="250" :displayDescription="true" v-model="salesGroup.sales_team_code" @set-code="setTeam" />
								</span>
								<!-- <em class="lt_text">{{ salesGroup.sales_team_name }}</em> -->
							</td>
							<tr>
								<th>Description</th>
								<td><input type="text" v-model.trim="salesGroup.description" class="tbl_int full_int" /></td>
							</tr>
							<tr>
								<th>Monthly<br />Sales Target</th>
								<td>
									<currency-input type="text" v-model.trim="salesGroup.monthly_sales_goal" :precision="0" :allow-negative="false" class="tbl_int sm_int al_right" @focus="$event.target.select()" />
								</td>
							</tr>
							<!-- #3252 : beautyplus 는 Order No 를 쓰지 않는다. 입력을 숨겨도 로드된 기존 값은
							     salesGroup 객체에 남아 update 때 그대로 전송된다(값 보존). -->
							<tr v-if="!isBeautyplus">
								<th>Order No</th>
								<td><input type="number" v-model.trim="salesGroup.order_no" class="tbl_int sm_int" /></td>
							</tr>
							<tr>
								<th></th>
								<td>
									<label for="active_yn" style="margin-left:5px;"> <input type="checkbox" id="active_yn" v-model="salesGroup.active_yn" true-value="Y" false-value="N" />Active</label>
								</td>
							</tr>
						</tbody>
					</table>

					<div v-if="modifiable" class="view_bottom_bt" style="padding-top:15px;">
						<a href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="submit()">Save</a>
						<a v-if="false" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()" class="delete_button">Delete</a>
					</div>
				</div>

				<div style="padding-top:30px;">
					<h4 class="inner_h5">Backup Users</h4>
					<div class="view_bottom_bt" style="padding-top:15px;">
						<a v-if="modifiable" href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'search_bt'" @click="addBackup()">Add Backup User</a>
					</div>
					<!-- #3252 : beautyplus 는 아래 State Access 섹션과 높이를 나눠 쓴다. 다른 회사는 종전 370px 그대로다. -->
					<div style="height:370px;" :style="stateAccessVisible ? { height: '240px', overflow: 'hidden' } : null">
						<div class="fixed-table-container state-access-backup-table" :style="stateAccessVisible ? { height: '100%', boxSizing: 'border-box' } : null">
							<div class="table-wrapper">
								<table id="item_list" class="list_tbl">
									<thead>
										<tr>
											<th style="text-align:center;width:15%;"><div class="th-text">User ID</div></th>
											<th style="text-align:center;width:25%;"><div class="th-text">Name</div></th>
											<th style="text-align:center;width:35%"><div class="th-text">Team</div></th>
											<th style="text-align:center;width:10%"><div class="th-text">Delete</div></th>
										</tr>
									</thead>

									<tbody>
										<tr v-for="backup in backups" v-bind:key="backup.backup_no">
											<td>{{ backup.user_id }}</td>
											<td>{{ backup.user_name }}</td>
											<td>{{ backup.sales_team_name }}</td>
											<td><button @click="deleteBackup(backup)">Delete</button></td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>

				<!-- #3252 : beautyplus 관리자에게만 보인다. 다른 회사에는 이 API 자체가 없다. -->
				<div v-if="stateAccessVisible" style="padding-top:30px;">
					<h4 class="inner_h5">State Access Users</h4>
					<!-- #3406 추가형(2026-10-28) : Restriction 은 자기 팀 범위를 바꾸지 않고, 지정 State 를 조회 전용으로 더해 보게 한다. -->
					<p class="state-access-help" style="padding-top:8px;color:#555;">
						Restriction ON keeps the viewer's own Sales Team access unchanged. The granted States are added as a read-only view, shown only when the viewer checks <b>Restriction Only</b> on SO Main, A/R History, A/R Aging or Partner Main. Only a
						non-admin salesman or a non-admin user with a Sales Team can be turned on.
					</p>
					<div class="view_bottom_bt" style="padding-top:15px;">
						<a href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'search_bt'" @click="selectStateViewer()">Select Viewer</a>
						<!-- #3406 : 새 조회자의 값이 오기 전에는 이전 조회자의 값을 보이거나 그 값으로 토글하지 않는다. -->
						<span v-if="stateViewer" style="padding-left:15px;">
							<b>{{ stateViewer.user_name || stateViewer.user_id }}</b>
							<button type="button" class="state-viewer-clear" @click="clearStateViewer()">
								Back to Group
							</button>
							&nbsp;|&nbsp; Restriction:
							<b class="state-viewer-mode">{{ stateViewerReady ? stateModeLabel : '…' }}</b>
							&nbsp;
							<button class="state-mode-toggle" :disabled="state_mode_busy || !stateViewerReady" @click="toggleStateMode()">
								{{ !stateViewerReady ? '…' : stateGlobalEnabled == 'Y' ? 'Turn Off' : 'Turn On' }}
							</button>
							<!-- #3406 : 자격 없는 계정은 서버가 ON 을 거부한다. 이유를 미리 보인다(OFF 는 언제나 가능). -->
							<span v-if="stateViewerReady && stateViewerEligible === 'N'" class="state-viewer-ineligible" style="color:#c0392b;">&nbsp;(not eligible: an admin, or not a salesman and no Sales Team)</span>
							&nbsp;|&nbsp; This group: {{ stateViewerReady ? stateSelectedGroupCount : '…' }} / Total: {{ stateViewerReady ? stateTotalCount : '…' }}
						</span>
					</div>

					<div v-if="stateViewer" class="view_bottom_bt" style="padding-top:10px;">
						<select v-model="stateCandidate" style="min-width:420px;">
							<option :value="null">-- Select Salesman / Country / State --</option>
							<option v-for="c in stateCandidates" :key="candidateKey(c)" :value="c"> {{ c.owner_salesman_name || c.owner_salesman_id }} / {{ c.country }} / {{ c.address_state }} ({{ c.store_count }}) </option>
						</select>
						&nbsp;
						<button class="state-grant-add" :disabled="state_mode_busy || !stateCandidate || !stateViewerReady" @click="addStateGrant()">
							Add
						</button>
					</div>

					<!--
						#3252 : 조회자를 고르기 전에도 이 그룹에 설정된 grant 를 보여준다.
						화면을 다시 열면 설정이 사라진 것처럼 보이던 문제 때문이다.
						그래서 행마다 조회자가 다를 수 있고 VIEWER 컬럼이 필요하다.
					-->
					<div v-if="stateViewer || stateGrants.length" style="height:240px;padding-top:10px;">
						<div class="fixed-table-container state-access-grant-table" style="height:100%;box-sizing:border-box;">
							<div class="table-wrapper">
								<table class="list_tbl">
									<thead>
										<tr>
											<th style="text-align:center;width:18%;"><div class="th-text">Viewer</div></th>
											<th style="text-align:center;width:14%;"><div class="th-text">Sales Group</div></th>
											<th style="text-align:center;width:18%"><div class="th-text">Salesman</div></th>
											<th style="text-align:center;width:10%"><div class="th-text">Country</div></th>
											<th style="text-align:center;width:10%"><div class="th-text">State</div></th>
											<th style="text-align:center;width:10%"><div class="th-text">Restriction</div></th>
											<th style="text-align:center;width:10%"><div class="th-text">Stores</div></th>
											<th style="text-align:center;width:10%"><div class="th-text">Delete</div></th>
										</tr>
									</thead>
									<tbody>
										<!-- #3406 : 화면을 다시 열어도 조회자별 ON/OFF 를 보고, 조회자를 눌러 바로 켜고 끌 수 있게 한다. -->
										<tr v-for="g in stateGrants" :key="grantKey(g)">
											<td>
												<!-- #3406 : 앱 전역 a 스타일은 링크 표시가 없어 누를 수 있는지 알기 어렵다. 여기만 링크 모양을 준다. -->
												<a href="javascript:;" class="state-viewer-link" style="color:#1d5fbf;text-decoration:underline;" title="Select this viewer" @click="selectStateViewerRow(g)">{{ g.viewer_user_name || g.viewer_user_id }}</a>
											</td>
											<td>{{ g.source_sales_group_name || g.source_sales_group_code }}</td>
											<td>{{ g.owner_salesman_name || g.owner_salesman_id }}</td>
											<td>{{ g.country }}</td>
											<td>{{ g.address_state }}</td>
											<td class="state-viewer-enabled" style="text-align:center;">
												<button type="button" class="state-row-mode" :disabled="state_mode_busy || (!!stateViewer && !stateViewerReady)" title="Change this viewer's Restriction across all Sales Groups" @click="toggleStateMode(g)">
													{{ stateRowMode(g) }}
												</button>
											</td>
											<td style="text-align:right;">{{ g.store_count }}</td>
											<td>
												<button :disabled="state_mode_busy" @click="deleteStateGrant(g)">
													Delete
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'StateViewerSelect'" :draggable="false">
			<template slot="title">Select Viewer</template>
			<template slot="body">
				<UserPopup v-on:close="closeModal()" @set-users="setStateViewer" :initialDeptCode="salesmanDeptCode" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'UserSelect'" :draggable="false">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Select User(s)</template>
			<template slot="body">
				<UserPopup v-on:close="closeModal()" @set-users="setUsers" :initialDeptCode="salesmanDeptCode" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectStateAccessList, apiSelectStateAccessCandidates, apiSaveStateAccessGrant, apiDeleteStateAccessGrant, apiChangeStateAccessMode } from '@/api/basicinfo/state_access.js';
import {
	apiIndex,
	apiSelectSalesGroupList,
	apiCheckSalesGroupExists,
	apiGetNewSalesGroupCode,
	apiInsertSalesGroup,
	apiUpdateSalesGroup,
	apiDeleteSalesGroup,
	apiSelectSalesBackupList,
	apiInsertSalesBackups,
	apiDeleteSalesBackup,
} from '@/api/basicinfo/salesgroup.js';
import CodeSelect from '@/components/common/CodeSelect';
import UserPopup from '@/components/common/UserPopup';
import Modal from '@/components/common/Modal';
import _ from 'lodash';
import '@/assets/css/table_box.css';

// #3406 : 자격 없는 계정(영업사원도 아니고 팀도 없음)의 기존 ON 행 표시.
const STATE_INVALID_ON = 'ON (invalid: not eligible)';

export default {
	data: function() {
		return {
			backUri: '/',
			active_yn: 'Y',
			mode: null,
			//codeTypes: ['Remarks', 'Department', 'Truck'],
			keyword: '',

			salesGroups: [],
			selectedSalesGroup: {},

			salesteam_code: '',
			//salesteam_name: '',
			// selectedCode: {
			// 	code: null,
			// 	name: null,
			// },

			salesteams: [],

			salesGroup: {},

			backups: [],

			//selectedCode: null,

			modalName: '',
			showModal: false,

			// #3252
			stateViewer: null,
			stateGrants: [],
			stateCandidates: [],
			stateCandidate: null,
			stateGlobalEnabled: 'N',
			stateTotalCount: 0,
			stateSelectedGroupCount: 0,
			// #3406 : 선택한 조회자의 Restriction·건수가 지금 응답의 값인지. 갱신·관리 동작 중에는 false 다.
			stateViewerReady: false,
			// #3406 : 그룹 전체 보기에서도 토글·grant 변경은 한 번에 하나만 처리한다.
			state_mode_busy: false,
			// #3406 추가형 : 선택한 조회자가 Restriction ON 자격(영업사원이거나 팀 있음, 관리자 아님)이 있는지. 'Y'/'N', 모르면 null.
			stateViewerEligible: null,
			// #3252 : 그룹을 빠르게 옮기면 요청이 겹친다. 응답이 도착했을 때 그 요청이
			// 아직 현재 선택의 것인지 판단하려고 요청마다 번호를 매긴다.
			stateRequestSeq: 0,
			// #3252 : beautyplus 목록의 Territory 표시용 code → territory. 서버가 세션 회사로
			// 판정해 beautyplus 응답에만 실어 준다. 다른 회사는 빈 객체로 남는다.
			territoryMap: {},
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		// #3252 : 목록 표시(Territory·No.·Order 숨김)만 가르는 회사 판정.
		// stateAccessVisible 과 달리 admin·mode·선택 그룹과 무관하다.
		isBeautyplus() {
			var u = this.$session.get('user');
			return !!u && u.company_id === 'beautyplus';
		},
		// #3252 : 응답 시점 세션의 회사를 본다. 다른 회사에는 이 기능이 없다.
		stateAccessVisible() {
			var u = this.$session.get('user');
			return !!u && u.company_id === 'beautyplus' && u.admin_yn === 'Y' && this.mode == 'detail' && !!this.selectedSalesGroup;
		},
		// #3252 : beautyplus 의 두 사용자 팝업만 세일즈맨 부서를 먼저 걸러 연다.
		// null 이면 UserPopup 의 기본값과 같아 다른 회사·다른 화면은 종전대로 전 부서를 본다.
		salesmanDeptCode() {
			var u = this.$session.get('user');
			return !!u && u.company_id === 'beautyplus' ? '3000' : null;
		},
		// #3406 : 선택한 조회자의 Restriction 표시. 자격 없는 계정의 ON 은 아무것도 제한하지 않으므로 무효로 구분한다.
		stateModeLabel() {
			if (this.stateGlobalEnabled != 'Y') return 'OFF';
			return this.stateViewerEligible === 'N' ? STATE_INVALID_ON : 'ON';
		},
		isValid() {
			if (!this.salesGroup) return false;
			else return true;
		},
		isDeletable() {
			//if (this.mode == 'detail' && this.codes.length > 0 && this.code) return true;
			if (this.mode == 'detail' && this.selectedSalesGroup) return true;
			else return false;
		},
		modifiable() {
			if (this.user.admin_yn == 'Y') return true;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		filteredSalesGroups() {
			return this.salesGroups.filter(group => {
				const keyword = this.keyword.toLowerCase();
				// #3252 : beautyplus 는 화면에 보이는 값이 Territory 이므로 검색도 그 값을 대상으로 한다.
				const description = this.isBeautyplus ? this.territoryOf(group).toLowerCase() : group.description ? group.description.toLowerCase() : '';
				const team = group.sales_team_name ? group.sales_team_name.toLowerCase() : '';
				const teamDescription = group.team_description ? group.team_description.toLowerCase() : '';
				return description.includes(keyword) || team.includes(keyword) || teamDescription.includes(keyword);
			});
		},
		// sortedCodeTypes() {
		// 	return _.orderBy(this.$codeTypes, 'text', 'asc'); // 오름차순 :: asc
		// },
	},

	watch: {
		backups: function(newVal) {
			this.selectedSalesGroup.backup_count = newVal.length;
		},
		// #3252 : 다른 Sales Group 으로 옮기면 이 그룹 기준 건수와 후보가 달라진다.
		// 갱신하지 않으면 이전 그룹의 숫자를 보고 판단하게 된다.
		// 조회자를 고르지 않았어도 그룹에 설정된 grant 는 보여야 하므로 조건 없이 부른다.
		// 실제 호출 여부는 refreshStateAccess 의 가드가 판단한다.
		selectedSalesGroup: function() {
			this.refreshStateAccess();
		},
	},
	components: {
		CodeSelect,
		UserPopup,
		Modal,
	},
	methods: {
		addBackup() {
			this.modalName = 'UserSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		async setUsers(selectedUserIds) {
			//console.log(selectedUserIds);
			const { data } = await apiInsertSalesBackups({
				sales_group_code: this.selectedSalesGroup.code,
				user_ids: selectedUserIds,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.selectSalesBackups();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async deleteBackup(backup) {
			if (confirm('Are you sure to delete the backup user?')) {
				const { data } = await apiDeleteSalesBackup(backup);
				if (data.result) {
					this.$toast.success('Backup User deleted successfully');
					const idx = this.backups.findIndex(function(item) {
						return item.backup_no === backup.backup_no;
					});
					this.backups.splice(idx, 1);
				}
			}
		},
		// #3252 ---------------------------------------------------------------
		candidateKey(c) {
			return [c.source_sales_group_code, c.owner_salesman_id, c.country, c.address_state].join('|');
		},
		// #3252 : 그룹 전체 목록에는 조회자가 다른 같은 조합이 함께 나올 수 있다.
		// 조회자를 key 에 넣지 않으면 두 행이 같은 key 가 되어 렌더가 어긋난다.
		grantKey(g) {
			return [g.viewer_user_id, g.source_sales_group_code, g.owner_salesman_id, g.country, g.address_state].join('|');
		},
		// #3406 : 행의 Restriction 표시. 자격은 행 값(viewer_eligible_yn)이 있으면 그 값을, 없으면 지금 응답이 준
		// 선택 조회자의 값을 쓴다. 자격을 모르는 다른 조회자 행은 종전처럼 ON 으로 둔다.
		stateRowMode(g) {
			if (g.viewer_enabled_yn != 'Y') return 'OFF';
			const selected = this.stateViewerReady && !!this.stateViewer && this.stateViewer.user_id === g.viewer_user_id;
			const eligible = g.viewer_eligible_yn || (selected ? this.stateViewerEligible : null);
			return eligible === 'N' ? STATE_INVALID_ON : 'ON';
		},
		selectStateViewer() {
			this.modalName = 'StateViewerSelect';
			this.showModal = true;
		},
		// #3252 : UserPopup 은 User 객체가 아니라 user_id 문자열 배열을 emit 한다.
		// 객체로 받으면 viewer_user_id 가 undefined 가 되어 목록·grant·mode 가 모두 빗나간다.
		async setStateViewer(selectedUserIds) {
			this.closeModal();
			if (!selectedUserIds || !selectedUserIds.length) return;
			this.stateViewer = { user_id: selectedUserIds[0] };
			await this.refreshStateAccess();
		},
		// #3406 : 표의 조회자를 누르면 Select Viewer 없이 그 조회자를 고른다.
		async selectStateViewerRow(g) {
			this.stateViewer = { user_id: g.viewer_user_id, user_name: g.viewer_user_name || null };
			await this.refreshStateAccess();
		},
		// #3406 : 조회자를 고르면 목록이 그 조회자 것으로 좁혀진다. 풀면 그룹 전체 조회자 목록으로 돌아간다.
		async clearStateViewer() {
			this.stateViewer = null;
			await this.refreshStateAccess();
		},
		stateParam(extra) {
			return Object.assign(
				{
					viewer_user_id: this.stateViewer ? this.stateViewer.user_id : null,
					source_sales_group_code: this.selectedSalesGroup ? this.selectedSalesGroup.code : null,
				},
				extra || {},
			);
		},
		async refreshStateAccess() {
			// #3252 : 이 요청의 번호. 뒤에 시작된 요청이 있으면 이 응답은 버린다.
			// 그룹을 빠르게 옮기면 응답 순서가 뒤집힐 수 있고, 그때 이전 그룹 목록이
			// 현재 그룹 화면에 남으면 관리자가 다른 그룹의 grant 를 지우게 된다.
			const seq = ++this.stateRequestSeq;
			// #3406 : 이 요청의 응답이 오기 전에는 조회자 값을 믿지 않는다. 가드보다 먼저 내린다.
			this.stateViewerReady = false;
			this.stateViewerEligible = null;

			// 갱신 중에는 이전 그룹의 행을 남기지 않는다. 응답이 늦게 오는 동안
			// 화면의 그룹과 표의 내용이 어긋나는 구간을 없앤다.
			this.stateGrants = [];
			this.stateCandidates = [];
			this.stateCandidate = null;

			// Add 모드의 빈 그룹({}) 이나 관리 대상이 아닌 회사에서는 부르지 않는다.
			// selectedSalesGroup 은 {} 도 truthy 라 code 까지 봐야 한다.
			if (!this.stateAccessVisible || !this.selectedSalesGroup || !this.selectedSalesGroup.code) return;

			const { data } = await apiSelectStateAccessList(this.stateParam());
			if (seq !== this.stateRequestSeq) return;
			this.stateGrants = data.list || [];

			// 조회자를 고르지 않았으면 목록만 보여준다. 활성 상태·건수·후보는 조회자 기준 값이다.
			if (!this.stateViewer) return;

			this.stateGlobalEnabled = data.global_enabled;
			this.stateTotalCount = data.total_grant_count;
			this.stateSelectedGroupCount = data.selected_group_grant_count;
			// #3406 : 서버가 조회자를 고른 목록에만 준다. 없으면(구버전 응답) 모름으로 두어 종전 표시를 유지한다.
			this.stateViewerEligible = data.viewer_eligible === 'Y' || data.viewer_eligible === 'N' ? data.viewer_eligible : null;
			// #3252 : UserPopup 은 id 만 주므로 이름은 목록 응답에서 받아 채운다.
			this.$set(this.stateViewer, 'user_name', data.viewer_user_name || null);
			// #3406 : 요청 순번이 맞았으므로 지금 선택한 조회자·그룹의 값이다.
			this.stateViewerReady = true;

			const res = await apiSelectStateAccessCandidates(this.stateParam());
			if (seq !== this.stateRequestSeq) return;
			this.stateCandidates = res.data.list || [];
			this.stateCandidate = null;
		},
		// #3406 : 행 대상은 선택 중인 조회자와 분리한다. 클릭 때의 목표 상태를 저장하며 화면 선택은 바꾸지 않는다.
		async toggleStateMode(grant) {
			if (!this.stateAccessVisible || this.state_mode_busy) return;
			if (grant ? !this.stateGrants.includes(grant) || (this.stateViewer && !this.stateViewerReady) : !this.stateViewer || !this.stateViewerReady) return;
			const selected_group = this.selectedSalesGroup;
			const selected_viewer = this.stateViewer;
			const request_seq = this.stateRequestSeq;
			const param = grant
				? {
						viewer_user_id: grant.viewer_user_id,
						source_sales_group_code: grant.source_sales_group_code,
				  }
				: this.stateParam();
			const turning_on = (grant ? grant.viewer_enabled_yn : this.stateGlobalEnabled) !== 'Y';
			let total_count = this.stateTotalCount;
			let eligible = this.stateViewerEligible;
			let refresh_needed = false;
			this.state_mode_busy = true;
			try {
				if (grant) {
					// 표시 뒤 grant나 상태가 바뀌어도 0건 확인을 지키고, 이미 목표 상태면 다시 뒤집지 않는다.
					const { data } = await apiSelectStateAccessList(param);
					if (request_seq !== this.stateRequestSeq || selected_group !== this.selectedSalesGroup || selected_viewer !== this.stateViewer || !this.stateAccessVisible) return;
					if ((data.global_enabled === 'Y') === turning_on) {
						refresh_needed = true;
						return;
					}
					total_count = data.total_grant_count;
					eligible = data.viewer_eligible;
				}
				// 자격 없는 ON은 서버의 거부 문구를 보인다. 기존 0 grant 확인은 유지한다.
				if (turning_on && total_count === 0 && eligible !== 'N') {
					if (!confirm('This viewer has no State grants yet. The viewer keeps their own Sales Team access, but Restriction Only will show no customers until a grant is added. Continue?')) return;
				}
				this.stateViewerReady = false;
				refresh_needed = true;
				const { data } = await apiChangeStateAccessMode(Object.assign({}, param, { enabled: turning_on }));
				if (!data.result) this.$toast.error(data.message || 'The restriction could not be changed.');
			} catch (error) {
				this.$toast.error(refresh_needed ? 'The restriction change could not be confirmed. Check the refreshed status before retrying.' : 'The current restriction could not be loaded. Please try again.');
			} finally {
				await this.finishStateAccessChange(refresh_needed);
			}
		},
		async finishStateAccessChange(refresh_needed = true) {
			try {
				if (refresh_needed) await this.refreshStateAccess();
			} catch (error) {
				this.$toast.error('The current State Access could not be refreshed. Select the Sales Group again to retry.');
			} finally {
				this.state_mode_busy = false;
			}
		},
		async addStateGrant() {
			if (this.state_mode_busy || !this.stateCandidate || !this.stateViewerReady) return;
			const c = this.stateCandidate;
			this.state_mode_busy = true;
			this.stateViewerReady = false;
			try {
				const { data } = await apiSaveStateAccessGrant(
					this.stateParam({
						owner_salesman_id: c.owner_salesman_id,
						country: c.country,
						address_state: c.address_state,
					}),
				);
				if (!data.result) this.$toast.error(data.message);
			} catch (error) {
				this.$toast.error('The State grant change could not be confirmed. Check the refreshed list before retrying.');
			} finally {
				await this.finishStateAccessChange();
			}
		},
		async deleteStateGrant(g) {
			if (this.state_mode_busy) return;
			if (!confirm('Are you sure to delete this State grant?')) return;
			this.state_mode_busy = true;
			this.stateViewerReady = false;
			// #3252 : 그룹 전체 목록에서는 행의 조회자가 선택된 조회자와 다를 수 있다.
			// stateParam 의 선택 조회자를 쓰면 엉뚱한 행을 지우거나 아무것도 지우지 못한다.
			try {
				const { data } = await apiDeleteStateAccessGrant({
					viewer_user_id: g.viewer_user_id,
					source_sales_group_code: g.source_sales_group_code,
					owner_salesman_id: g.owner_salesman_id,
					country: g.country,
					address_state: g.address_state,
				});
				if (!data.result) this.$toast.error(data.message);
			} catch (error) {
				this.$toast.error('The State grant change could not be confirmed. Check the refreshed list before retrying.');
			} finally {
				await this.finishStateAccessChange();
			}
		},
		// ---------------------------------------------------------------------
		async selectSalesBackups() {
			const { data } = await apiSelectSalesBackupList({
				sales_group_code: this.selectedSalesGroup.code,
			});

			//console.log(data);
			this.backups = data.backupList;
		},
		reset() {
			this.keyword = '';
			this.salesteam_code = null;

			this.selectSalesGroups();
			//this.active_yn = 'Y';
		},
		async selectSalesGroups() {
			const { data } = await apiSelectSalesGroupList({
				active_yn: this.active_yn,
				salesteam_code: this.salesteam_code,
			});

			//console.log(data);
			this.salesGroups = data.salesGroupList;
			// #3252 : beautyplus 응답에만 territoryMap 이 실려 온다.
			this.territoryMap = data.territoryMap || {};
			if (this.salesGroups.length > 0) this.selectRow(this.salesGroups[0]);
			else this.salesGroup = {};
			//else this.selectedCode = null;
		},
		// #3252 : Partner 배정이 없는 그룹은 빈 문자열로 표시한다.
		territoryOf(group) {
			return this.territoryMap[group.code] || '';
		},
		async add() {
			this.mode = 'add';

			const { data } = await apiGetNewSalesGroupCode();
			this.salesGroup = { code: data.code, active_yn: 'Y' };
			// #3252 : beautyplus 는 Order No 입력이 없다. INSERT 의 #{order_no} 계약을 지키도록
			// 신규 등록은 0 을 명시해 보낸다. 다른 회사는 종전대로 입력값을 쓴다.
			if (this.isBeautyplus) this.salesGroup.order_no = 0;
			this.backups = [];

			this.selectedCode = {};
			//this.$refs.code.focus();

			this.selectedSalesGroup = {};

			//const { data } = await apiGetNewSalesGroupCode();
			//this.salesGroup.code = data.code;
			//this.setNewCode();
			//console.log(this.salesGroup);
			//this.salesGroup.code = this.getNewCode();
			//this.selectedCode.code_type = this.code_type;
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate Code');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkExists() {
			const { data } = await apiCheckSalesGroupExists(this.salesGroup);
			return data.result;
		},
		async submit() {
			if (!this.isValid) return;

			if (!this.salesGroup.code) {
				this.$toast.error('Empty Code');
				return;
			}

			if (!this.salesGroup.name) {
				this.$toast.error('Empty Name');
				return;
			}

			if (!this.salesGroup.sales_team_code) {
				this.$toast.error('Empty Team');
				return;
			}

			var response;
			var was_add = this.mode == 'add';
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Code');
					return;
				}
				response = await apiInsertSalesGroup(this.salesGroup);
			} else {
				response = await apiUpdateSalesGroup(this.salesGroup);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'add') {
					this.salesGroups.push(this.salesGroup);
				}

				Object.assign(this.selectedSalesGroup, this.salesGroup);
			} else {
				this.$toast.error(data.msg);
			}

			this.mode = 'detail';
			// #3406 : Add 는 빈 그룹 객체를 그대로 채우므로 그룹 감시가 돌지 않는다. 새 그룹 기준으로 다시 읽는다.
			if (was_add && data.result) await this.refreshStateAccess();
		},
		async del() {
			if (!this.isDeletable) return;

			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteSalesGroup(this.salesGroup);

				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.selectSalesGroups();
				} else {
					this.$toast.error('Failed');
				}
			}
			//console.log('delete');
		},
		selectRow(salesGroup) {
			this.mode = 'detail';
			// #3406 : 그룹 행을 누르면 State Access 조회자 선택을 풀고 그 그룹에 지정한 조회자를 모두 보인다.
			// 같은 그룹을 다시 누르면 selectedSalesGroup 이 바뀌지 않아 그룹 감시가 돌지 않으므로 여기서 다시 읽는다.
			const same_group = this.selectedSalesGroup === salesGroup;
			this.stateViewer = null;
			this.selectedSalesGroup = salesGroup;

			this.salesGroup = _.cloneDeep(salesGroup);

			this.selectSalesBackups();
			if (same_group) this.refreshStateAccess();
			//console.log(code);
		},
		//setSalesteam(code) {
		setSalesteam() {
			//console.log(code);
			// if (code) this.salesteam_name = code.name + ' (' + code.description + ')';
			// else this.salesteam_name = '';

			this.selectSalesGroups();
		},
		setTeam(team) {
			//console.log(team);
			if (team) this.salesGroup.sales_team_name = team.name;
		},
		async index() {
			const { data } = await apiIndex();

			this.salesteams = data.salesteamList;
		},
		async init() {
			await this.index();
		},
	},
	created() {
		this.backUri = '/';

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_salesgroup');
		this.$store.commit('setSubTitle', 'Basic Information -> Sales Group');

		this.init();
		this.selectSalesGroups();
	},
	mounted() {
		inputSelectOnClick();

		$('.table-wrapper').on('scroll', function() {
			if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
				//var $rows = $('#item_list tbody tr');
				var $rows = $('.list_table tbody tr');
				var lastActiveIndex = $rows.filter('.active:last').index();
				$rows.filter(':lt(' + (lastActiveIndex + 25) + ')').addClass('active');
			}
		});

		window.addEventListener('keypress', event => {
			//console.log(event.target.tagName.toUpperCase());
			if (event.target.tagName.toUpperCase() == 'BODY') {
				//console.log('target body', event.key);
				if (event.which !== 0) {
					//console.log("Character was typed. It was: " + String.fromCharCode(e.which));
					var search_character = String.fromCharCode(event.which);

					// #3252 : beautyplus 는 그룹 목록 맨 앞에 No. 컬럼이 있어 Code 셀이 한 칸 밀린다.
					// id 가 중복된 Backup Users 표(right_tbl)의 행도 이 선택자에 걸리는데,
					// 그 표에는 No. 컬럼이 없으므로 종전대로 첫 셀(User ID)을 읽는다.
					var code_cell_index = this.isBeautyplus ? 1 : 0;
					$('#item_list > tbody > tr').each(function() {
						var cell_index = $(this).closest('.right_tbl').length ? 0 : code_cell_index;
						var textval = $(this)
							.find('td')
							.eq(cell_index)
							.text();
						if (textval.substring(0, 1).toUpperCase() == search_character.toUpperCase()) {
							$(this)
								.get(0)
								.scrollIntoView();
							return false;
						}
					});
				}
			}
			//console.log(e.target);
			// if (e.key == 'Escape') {
			// 	this.showModal = !this.showModal;
			// }
		});
	},
};
</script>

<style></style>
